import {Component, OnInit} from '@angular/core';
import {ModulesItems} from './app.modules-item';
import {MinifyNavigationService} from '../../core/minify-navigation/minify-navigation.service';

@Component({
    selector: 'smart-modules',
    templateUrl: './modules.component.html',
    styleUrls: ['./modules.component.css']
})
export class ModulesComponent implements OnInit {

    modulesItems = ModulesItems;

    constructor(private minifyService: MinifyNavigationService) {
        // if (this.minifyService.isMinify()) {
        //     this.minifyService.changeMinifyState();
        // }
    }

    ngOnInit() {
    }


}

